import { useNavigation as useNavigationDefault, useRoute as useRouteDefault } from '@react-navigation/native';
import { NavigationParamsList, NavigationProp, RouteProp } from '../navigation/RootNavigator';

export const useAppNavigation = <T extends keyof NavigationParamsList = never>(): NavigationProp<T> =>
  useNavigationDefault<NavigationProp<T>>();

export const useAppRoute = <T extends keyof NavigationParamsList>(): RouteProp<T> => useRouteDefault<RouteProp<T>>();
